<template>
    <header class="navbar" @click.stop="subabout = false, subservices = false">
        <div
            class="header"

            v-if="globalsIsLoaded"
        >
            <router-link :to="{ name: 'HomePage-' + $route.meta.lang }" class="logo">
                <img src="@/assets/img/logo-icon.svg" alt="Logo St-Denis Thompson" class="icon" />
                <img src="@/assets/img/logo-text.svg" alt="Logo St-Denis Thompson" class="text" />
            </router-link>

            <nav>
                <div class="drop" :class="{ 'clicked': subabout }" >
                    <button class="link" :class="{ 'router-link-active': $route.name.includes('About') }" @click.prevent.stop=";(subabout = !subabout), (subservices = false)">{{
                        $t('À propos')
                    }}</button>
                    <!-- :to="{ name: 'About-' + $route.meta.lang }" -->
                    <svg
                        class="arrow"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.75 1.19995L4.5 4.44995L1.25 1.19995"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                </div>
                <router-link
                    :to="{ name: 'Realisations-' + $route.meta.lang }"
                    class="link"

                    >{{ $t('Réalisations') }}</router-link
                >
                <div class="drop" :class="{ 'clicked': subservices }">
                    <button class="link" :class="{ 'router-link-active': $route.name.includes('Service') }" @click.prevent.stop=";(subservices = !subservices), (subabout = false)">{{
                        $t('Services')
                    }}</button>
                    <!-- :to="{ name: 'Services-' + $route.meta.lang }" -->
                    <svg
                        class="arrow"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.75 1.19995L4.5 4.44995L1.25 1.19995"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>

                <a :href="'https://jobs.glowinthecloud.com/st-denis-thompson?l=' + $route.meta.lang" target="_blank" rel="noopener noreferrer" class="link">
                    {{ $t('Carrières') }}
                    <svg class="arrow arrow-external" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
                        <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6"></path>
                        <path d="M11 13l9 -9"></path>
                        <path d="M15 4h5v5"></path>
                    </svg>
                </a>

                <router-link
                    v-if="$route.name.includes('Actualite')"
                    :to="{ name: 'Actualite-' + $route.meta.lang }"
                    class="link"
                    >{{ $t('Actualité') }}</router-link
                >
                <router-link
                    :to="{ name: 'Contact-' + $route.meta.lang }"
                    class="link cta"

                    >{{ $t('Nous joindre') }}</router-link
                >
                <router-link v-if="pageIsLoaded && $route.meta.lang === 'fr'" :to="content.urls['en']" class="link lang">EN</router-link>
                <router-link v-else :to="pageIsLoaded && content.urls['fr'] ? content.urls['fr'] : ''" class="link lang">FR</router-link>
            </nav>

            <div class="burger" @click.prevent="showMobileMenu">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div v-if="globalsIsLoaded" class="submenus" :class="{ 'is-active': subabout || subservices }">
                <div class="submenu grid grid2 gap60" :class="{ 'is-active': subabout }">
                    <div class="left">
                        <h2>{{ $t('À propos') }}</h2>
                        <div class="submenu-links">
                            <a
                                href="/a-propos"
                                class="regular-text"
                                >{{ $t('Entreprise') }}</a
                            >

                            <a
                                href="/a-propos#mission"
                                class="regular-text"
                                >{{ $t('Mission et vision') }}</a
                            >

                            <a
                                href="/a-propos#valeurs"
                                class="regular-text"
                                >{{ $t('Valeurs') }}</a
                            >
                            <router-link
                                :to="{ name: 'Historique-' + $route.meta.lang }"
                                class="regular-text"
                                >{{ $t('Historique') }}</router-link
                            >
                            <router-link
                                :to="{ name: 'Direction-' + $route.meta.lang }"
                                class="regular-text"
                                >{{ $t('Direction') }}</router-link
                            >
                            <router-link
                                :to="{ name: 'Prix-' + $route.meta.lang }"
                                class="regular-text"
                                >{{ $t('Prix et distinctions') }}</router-link
                            >
                        </div>
                    </div>
                    <div class="right">
                        <img :src="globals.footer.navAboutImg.url" alt="">
                    </div>
                </div>

                <div class="submenu grid grid2 gap60" :class="{ 'is-active': subservices }">
                    <div class="left">
                        <h2>{{ $t('Services') }}</h2>
                        <div class="submenu-links">
                            <router-link
                                v-for="(item, index) in globals.servicesEntry.data"
                                class="regular-text"
                                :key="index"
                                :to="item.page.jsonUrl"
                                >{{ item.page.titre }}</router-link
                            >
                            <!-- Voir tout les services "/services" -->
                            <router-link
                                :to="{ name: 'Services-' + $route.meta.lang }"
                                class="regular-text"
                                >{{ $t('Tous les services') }}</router-link
                            >
                        </div>
                    </div>
                    <div class="right">
                        <img :src="globals.footer.navServicesImg.url" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile_menu" :class="{ show: menuIsOpen }" v-if="globalsIsLoaded" @click.stop="menuIsOpen = false">
            <div class="menu">
                <img
                    src="@/assets/img/close.svg"
                    class="close"
                    alt="Close"
                    @click.prevent="showMobileMenu"
                />
                <nav>
                    <router-link
                        :to="{ name: 'About-' + $route.meta.lang }"
                        class="title small line"
                        >{{ $t('À propos') }}</router-link
                    >
                    <div class="sub">
                        <a
                            href="/a-propos"
                            class="regular-text"
                            >{{ $t('Entreprise') }}</a
                        >
                        <a
                            href="/a-propos#mission"
                            class="regular-text"
                            >{{ $t('Mission et vision') }}</a
                        >
                        <a
                            href="/a-propos#valeurs"
                            class="regular-text"
                            >{{ $t('Valeurs') }}</a
                        >
                        <router-link
                            :to="{ name: 'Historique-' + $route.meta.lang }"
                            class="regular-text"
                            >{{ $t('Historique') }}</router-link
                        >
                        <router-link
                            :to="{ name: 'Direction-' + $route.meta.lang }"
                            class="regular-text"
                            >{{ $t('Direction') }}</router-link
                        >
                        <router-link
                            :to="{ name: 'Prix-' + $route.meta.lang }"
                            class="regular-text"
                            >{{ $t('Prix et distinctions') }}</router-link
                        >
                    </div>
                    <router-link
                        :to="{ name: 'Realisations-' + $route.meta.lang }"
                        class="title small line"
                        >{{ $t('Réalisations') }}</router-link
                    >
                    <router-link
                        :to="{ name: 'Services-' + $route.meta.lang }"
                        class="title small line"
                        >{{ $t('Services') }}</router-link
                    >
                    <div class="sub">
                        <router-link
                            v-for="(item, index) in globals.servicesEntry.data"
                            class="regular-text"
                            :key="index"
                            :to="item.page.jsonUrl"
                            >{{ item.page.titre }}</router-link
                        >
                        <!-- Voir tout les services "/services" -->
                        <router-link
                            :to="{ name: 'Services-' + $route.meta.lang }"
                            class="regular-text"
                            >{{ $t('Tous les services') }}</router-link
                        >
                    </div>

                    <a :href="'https://jobs.glowinthecloud.com/st-denis-thompson?l=' + $route.meta.lang" target="_blank" rel="noopener noreferrer" class="title small line">
                        {{ $t('Carrières') }}
                        <svg class="arrow arrow-external" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
                            <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6"></path>
                            <path d="M11 13l9 -9"></path>
                            <path d="M15 4h5v5"></path>
                        </svg>
                    </a>

                    <router-link :to="{ name: 'Contact-' + $route.meta.lang }" class="link cta">{{
                        $t('Nous joindre')
                    }}</router-link>

                    <router-link v-if="pageIsLoaded && $route.meta.lang === 'fr'" :to="content.urls['en']" class="title lang">EN</router-link>
                    <router-link v-else :to="pageIsLoaded && content.urls['fr'] ? content.urls['fr'] : ''" class="title lang">FR</router-link>
                </nav>
            </div>
            <div class="overlay" @click.prevent="showMobileMenu"></div>
        </div>

    </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    data() {
        return {
            subabout: false,
            subservices: false,
            menuIsOpen: false,
        }
    },
    mounted() {
        // On clicl outside of the menu nav links, close the submenus
        document.addEventListener('click', (event) => {
            const target = event.target
            if (
                !target.closest('.drop') &&
                !target.closest('.mobile_menu') &&
                !target.closest('.burger')
            ) {
                this.subabout = false
                this.subservices = false
            }
        })
    },
    methods: {
        showMobileMenu() {
            if (this.menuIsOpen) {
                this.menuIsOpen = false
            } else {
                this.menuIsOpen = true
            }
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/02-Tools/variables.scss';
</style>
